export default __webpack_public_path__ + "images/0xa48d959ae2e88f1daa7d5f611e01908106de7598.png";